import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface NormalTopBarProps {
  boxClassName?: string
  textClassName?: string
  prevButton?: boolean
  title?: string
  leftSide?: ReactNode
  rightSide?: ReactNode
  onPrevButtonClick?: () => void
}

const NormalTopBar = ({
  boxClassName,
  textClassName,
  prevButton,
  title,
  leftSide,
  rightSide,
  onPrevButtonClick
}: NormalTopBarProps) => {
  return (
    <div
      className={twMerge(
        'h-[60px] py-4 px-5 flex flex-col gap-3 flex flex-row justify-between items-center sticky top-0 z-10',
        boxClassName
      )}
    >
      <div className='flex flex-row gap-1'>
        {prevButton && (
          <button onClick={onPrevButtonClick}>
            <ChevronLeft className={twMerge('w-6 h-6', textClassName)} />
          </button>
        )}
        {leftSide && leftSide}
        {title && <p className={twMerge('font-bold text-amber-900', textClassName)}>{title}</p>}
      </div>
      <div className='flex flex-row gap-1'>{rightSide && rightSide}</div>
    </div>
  )
}

export default NormalTopBar
